function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m8978.351 132.35 5 5zm-13.7-5.749a7.949 7.949 0 1 1 7.949 7.949 7.95 7.95 0 0 1-7.948-7.95z",
  "data-name": "\\uD569\\uCE58\\uAE30 64",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1.3px"
  },
  transform: "translate(-8958.053 -111.35)"
}));
export default SvgIconSearch;